import styled from 'styled-components'

import { colors } from 'themes'

import prevIcon from 'images/prevIcon.svg'

export const Container = styled.div<{ showRedesignedVersion: boolean }>`
	.react-calendar {
		background: ${props => (props.showRedesignedVersion ? colors.calendarRedesigned.background : colors.calendar.background)};
		color: ${props => (props.showRedesignedVersion ? colors.calendarRedesigned.text : colors.calendar.text)};
		border-radius: 14px;
		width: 100%;
		border: none;
		overflow: hidden;
	}
	.navigation-label {
		font-size: 16px;
		color: ${props => (props.showRedesignedVersion ? colors.calendarRedesigned.headerText : colors.calendar.headerText)};
	}
	.react-calendar__navigation {
		background-color: ${props => (props.showRedesignedVersion ? colors.calendarRedesigned.headerBackground : colors.calendar.headerBackground)};
		margin-bottom: 0;
	}
	.react-calendar__month-view__weekdays {
		font-weight: normal;
		>:first-child, >:last-child {
			background-color: ${props => (props.showRedesignedVersion ? colors.calendarRedesigned.weekendsBackground : colors.calendar.weekendsBackground)};
		}
	}
	
	.react-calendar__tile--active {
		color: ${props => (props.showRedesignedVersion ? colors.calendarRedesigned.activeText : colors.calendar.activeText)} !important;
		background-color: ${props => (props.showRedesignedVersion ? colors.calendarRedesigned.activeBackground : colors.calendar.activeBackground)} !important;
	}
	
	.tile {
		font-weight: bold;
		padding: 8px 0;
		transition: 300ms ease;
	}
	.react-calendar__month-view__days__day--weekend {
		background-color: ${props => (props.showRedesignedVersion ? colors.calendarRedesigned.weekendsBackground : colors.calendar.weekendsBackground)};
	}
	.react-calendar__month-view__days__day--weekend:not(.react-calendar__month-view__days__day--neighboringMonth) {
		color: ${props => (props.showRedesignedVersion ? colors.calendarRedesigned.text : colors.calendar.text)};
	}
`

export const PrevMonthIcon = styled.img.attrs({
	src: prevIcon,
})``

export const NextMonthIcon = styled(PrevMonthIcon)`
	transform: rotate(180deg);
`
